
    var riot = require('riot')
    
import _ from 'lodash'
riot.tag2('saijiki-calendar-menus', '<div class="c-saijiki-calendar__menus"> <div class="area-list is-{opts.state.kind}"> <div class="area-list-head"> <p>エリア</p><i class="ion-ios-play"></i> </div> <div class="area-list-body"> <ul if="{opts.state.areas}"> <li each="{i in areaNames()}"><a class="{isCurrentArea(i.id)}" href="{areaLink(i.id)}">{i.name}</a></li> </ul> </div> </div> </div>', '', '', function(opts) {
    const self = this

    self.areaNames = () => {
      let areas = _.map(self.opts.state.areas, (i, id) => {
        let name = i.split('エリア')[0]
        return { id, name }
      })
      return areas
    }

    self.areaLink = (area_id) => {
      let query = $.url().param()
      query.area = area_id
      let qs = _.map(query, (val, key) => {
        return `${key}=${val}`
      })
      let endpoint =  `${location.pathname}?${qs.join('&')}`
      return endpoint
    }

    self.isCurrentArea = (id) => {
      let query = $.url().param()
      switch (true) {
        case (_.isUndefined(query.area) && id == 1):
          return 'current'
        case (id == query.area):
          return 'current'
        default:
          return null
      }
    }
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/saijiki-calendar/saijiki-calendar-menus.tag